"use strict";

// price-faq
document.addEventListener("DOMContentLoaded", () => {
  const detailsList = [...document.querySelectorAll(".js-details")];
  hydrateOpened(detailsList); // もしHTMLに open があれば同期
  // openFirst(detailsList); // 1件目を開いた状態で開始
  bindAccordion(detailsList); // クリック挙動
});

// faq
document.addEventListener("DOMContentLoaded", () => {
  const detailsList = [...document.querySelectorAll(".js-details2")];
  hydrateOpened(detailsList); // もしHTMLに open があれば同期
  // openFirst(detailsList); // 1件目を開いた状態で開始
  bindAccordion(detailsList); // クリック挙動
});
// training
document.addEventListener("DOMContentLoaded", () => {
  const detailsList = [...document.querySelectorAll(".js-details3")];
  hydrateOpened(detailsList); // もしHTMLに open があれば同期
  // openFirst(detailsList); // 1件目を開いた状態で開始
  bindAccordion(detailsList); // クリック挙動
});

const IS_OPENED_CLASS = "is-opened";

function hydrateOpened(list) {
  list.forEach((el) => {
    if (el.hasAttribute("open")) {
      el.classList.add(IS_OPENED_CLASS);
      const c = el.querySelector(".js-content");
      // アニメーションさせず“開いている”見た目を即セット
      gsap.set(c, { height: "auto", opacity: 1 });
    }
  });
}

function openFirst(list) {
  if (!list.length) return;
  const first = list[0];
  if (!first.classList.contains(IS_OPENED_CLASS)) {
    first.classList.add(IS_OPENED_CLASS);
    first.setAttribute("open", "true");
    const c = first.querySelector(".js-content");
    gsap.set(c, { height: "auto", opacity: 1 });
  }
}

function bindAccordion(detailsList) {
  detailsList.forEach((el) => {
    const summary = el.querySelector(".js-summary");
    const content = el.querySelector(".js-content");

    summary.addEventListener("click", (e) => {
      // ネイティブの開閉を止めて、GSAPで制御
      e.preventDefault();

      if (el.classList.contains(IS_OPENED_CLASS)) {
        el.classList.remove(IS_OPENED_CLASS);
        closingAnim(content, el).restart();
      } else {
        el.classList.add(IS_OPENED_CLASS);
        el.setAttribute("open", "true");
        openingAnim(content).restart();
      }
    });
  });
}

const closingAnim = (content, el) =>
  gsap.to(content, {
    height: 0,
    opacity: 0,
    duration: 0.4,
    ease: "power3.out",
    overwrite: true,
    onComplete: () => el.removeAttribute("open"),
  });

const openingAnim = (content) =>
  gsap.fromTo(
    content,
    { height: 0, opacity: 0 },
    { height: "auto", opacity: 1, duration: 0.4, ease: "power3.out", overwrite: true }
  );
